module.exports = __webpack_public_path__ + "img/1f60b.9592f50.svg";